<script setup>
import useGrid from "@/composables/useGrid";
import needsService from "@/services/needs.service";
import Grid from "../../../../frontend/src/components/Grid.vue";
import {onMounted} from "vue";
import {statuses} from "../../../../frontend/src/constants/needs"

const {items, gridParams, gridMethods} = useGrid(needsService.getList);

const statusOptions = Object.keys(statuses).map(key => ({id: key, name: statuses[key]}));

const columns = [
    {
        label: 'ID',
        name: 'id',
        sortable: true,
    },
    {
        label: 'Name',
        name: 'name',
        sortable: true,
        filter: 'text',
    },
    {
        label: 'Description',
        name: 'description',
        sortable: true,
        filter: 'text',
    },
    {
        label: 'Enterprise',
        name: 'enterprise_name',
        sortable: true,
        filter: 'text',
    },
    {
        label: 'Created by',
        name: 'user_email',
        sortable: true,
        filter: 'text',
    },
    {
        label: 'Created At',
        name: 'created_at',
        sortable: true,
    },
    {
        label: 'Is Shared',
        name: 'is_shared_with_ecosystems',
        sortable: true,
        filter: 'single-select',
        options: [
            {
                id: 1,
                name: 'Yes'
            },
            {
                id: 2,
                name: 'No'
            }
        ],
    },
    {
        label: 'Status',
        name: 'status',
        sortable: true,
        filter: 'single-select',
        options: statusOptions,
    },
    {
        label: 'Added by AI',
        name: 'ai_count',
        sortable: true,
    },
    {
        label: 'Added by Ecosystem',
        name: 'eco_count',
        sortable: true,
    },
    {
        label: 'Liked',
        name: 'liked_count',
        sortable: true,
    },
    {
        label: 'Disliked',
        name: 'disliked_count',
        sortable: true,
    },
    {
        name: 'actions',
        label: 'Link',
        component: 'Link',
    },
];

onMounted(() => {
    gridParams.sort = {
        field: 'id',
        dir: 'desc',
    };

    gridMethods.setColumns(columns);
    gridMethods.resetList();
});

</script>

<template>
    <div>
        <div class="main-table-wrapper">
            <div class="main-table overflow-auto">
                <Grid
                    :columns="columns"
                    :data="items"
                    has-filters
                    :page-length="parseInt(gridParams.pageLength)"
                    :total-rows-count="gridParams.totalRowsCount"
                    :sort="gridParams.sort"
                    :currentPage="gridParams.currentPage"
                    @changePage="gridMethods.changePage"
                    @changeFilters="gridMethods.setFilters"
                    @changeSort="gridMethods.changeSort"
                />
            </div>
        </div>
    </div>
</template>

<style scoped>

</style>
